import { useContext, useMemo } from "react";
import { AuthContext } from "../services/context";
import {
  getCurrentWorkspace,
  isCurrentEventAdmin,
} from "../services/userConfig";
import { useState } from "react";

import { useGetTags } from "../api/tag";
import TagsTable from "../components/Tags/TagsTable";
import { useSetActionButtons } from "../services/ActionButtonsContext";
import { IconColorSwatch, IconPlus } from "@tabler/icons-react";
import { useIsFeatureEnabled } from "../api/featureFlags";
import { FEATURE_FLAGS } from "@congrs/schemas";

function Tags() {
  const actions = useMemo(
    () => [
      {
        label: "Color tags",
        icon: <IconColorSwatch />,
        navigate: "./tags/colorTags",
      },
      {
        label: "Create",
        icon: <IconPlus />,
        navigate: "./tags/create",
      },
    ],
    []
  );

  useSetActionButtons(actions);

  const { user } = useContext(AuthContext);
  const [page, setPage] = useState(1);

  const [sort, setSort] = useState({
    columnAccessor: "title",
    direction: "asc",
  });

  const [typeFilter, setTypeFilter] = useState(null);
  const [subtypeFilter, setSubtypeFilter] = useState(null);

  const onFilterChange = (setter) => (value) => {
    setter(value);
    setPage(1);
  };

  const currentWorkspace = getCurrentWorkspace(user);
  const eventId = currentWorkspace.eventId;
  const interestTagsEnabled = useIsFeatureEnabled(
    eventId,
    FEATURE_FLAGS.ATTENDEE_INTERESTS_TAGS
  );

  const { data, isPending } = useGetTags({
    eventId,
    page,
    sort,
    type: typeFilter,
    subtype: subtypeFilter,
  });

  return (
    <TagsTable
      data={data}
      isLoading={isPending}
      enableActions={isCurrentEventAdmin(user)}
      page={page}
      setPage={setPage}
      sortStatus={sort}
      setSort={setSort}
      typeFilter={typeFilter}
      setTypeFilter={onFilterChange(setTypeFilter)}
      subtypeFilter={subtypeFilter}
      setSubtypeFilter={onFilterChange(setSubtypeFilter)}
      interestTagsEnabled={interestTagsEnabled}
    />
  );
}

export default Tags;
